// extracted by mini-css-extract-plugin
export default {"gachapon-img":"Gachapon-Machine_gachapon-img__11XFt","gachapon-button":"Gachapon-Machine_gachapon-button__+38dB"};